module.exports = __webpack_public_path__ + "img/wygl2.9b759533.png";